<script setup lang="ts">
import { mentorService } from '@/api/services/mentor-service'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { Mentor } from '@/types/mentor.types'
import { onMounted, ref } from 'vue'
import MentorListItem from './MentorListItem.vue'

const mentorList = ref<Mentor[]>([])

const isMobile = useIsMobile()

onMounted(async () => {
  const mentorCursorList = await mentorService.getMentors(null, 100, { ascending: false })
  mentorList.value = mentorCursorList.data
})
</script>

<template>
  <div class="mentor-list-section">
    <div class="title-md white" :class="{ 'title-sm': isMobile }">멘토 리스트</div>
    <div class="mentor-list">
      <MentorListItem v-for="mentor in mentorList" :key="mentor.idx" :mentor="mentor" />
    </div>
  </div>
</template>

<style scoped>
.mentor-list-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 60px;
}

.mentor-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 20px;
  row-gap: 40px;
}

@media (max-width: 1365px) {
  .mentor-list-section {
    width: 100%;
    padding: 0 20px;
    margin-top: 32px;
  }

  .mentor-list {
    grid-template-columns: 1fr 1fr;
    column-gap: 7px;
    row-gap: 20px;
  }
}
</style>
